import { useState } from 'preact/hooks';
import { Button, Modal, Card, Spinner, Row, Col, Form } from 'react-bootstrap';
import FileUploader from '../file-uploader';
import CodeEditor from "@uiw/react-textarea-code-editor"
import FileList from '../file-list';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faLinkSlash, faUpload } from '@fortawesome/free-solid-svg-icons';
import { route } from 'preact-router';

export default function DocumentUploadModal({ onHide, show, onFileSelect, onUpload }) {

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [document, setDocument] = useState({});
    const [errors, setErrors] = useState({});

    const handleUpload = () => {

        if (onUpload) {

            setUploading(true);

            // check if onUpload is a promise

            let onUploadResp = onUpload(selectedFiles, document);

            if (!(onUploadResp instanceof Promise)) {
                console.error("onUpload must return a promise");
                return;
            }

            onUploadResp.then(() => {
                setSelectedFiles([]);
            }).catch(e => {
                console.error(e);
            }).finally(() => {
                setUploading(false);
                onHide();
            });

        }

    }

    const handleFileSelect = (files = []) => {

        setSelectedFiles([...selectedFiles, ...files]);

        if (onFileSelect) {
            onFileSelect(files);
        }
    }

    const handleFileDelete = (file) => {
        setSelectedFiles(selectedFiles.filter(f => f != file));
    }

    const handleChange = (event) => {
        let { id, value } = event.target;

        setDocument({
            ...document,
            [id]: value
        });
    }

    return <>

        <Modal show={show ?? true} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Uploader un document</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FileUploader
                    onFileSelect={handleFileSelect}
                    acceptFormats={["image/jpeg", "image/png", "application/pdf"]}
                    maxSize={10000000000}
                    multiple={true}
                />

                <div className="mt-3">
                    <FileList files={selectedFiles} onDelete={handleFileDelete} />
                </div>

                <Card as="details" className="mt-3">
                    <Card.Header as="summary">
                        Infos
                    </Card.Header>
                    <Card.Body className='p-2'>
                        <Row>
                            <Col xs={12}>
                                <Form.Group className="mb-3" controlId="name">
                                    <Form.Label>Nom</Form.Label>
                                    <Form.Control
                                        type="text"
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <Form.Group className="mb-3" controlId="type">
                                    <Form.Label>Type</Form.Label>
                                    <Form.Control
                                        type="text"
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>

                            <Col xs={6}>
                                <Form.Group className="mb-3" controlId="subtype">
                                    <Form.Label>Sous Type</Form.Label>
                                    <Form.Control
                                        type="text"
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                <Card as="details" className="mt-3">
                    <Card.Header as="summary">
                        Metadata
                    </Card.Header>
                    <Card.Body className={`p-0`}>
                        <CodeEditor onChange={(e) => {

                            try {
                                handleChange({
                                    target: {
                                        id: 'metadata',
                                        value: e.target.value
                                    }
                                });

                                setErrors({
                                    metadata: null
                                });
                            } catch (e) {
                                console.error(e);
                                setErrors({
                                    metadata: "Invalid JSON: " + e?.message
                                });
                            }


                        }} value={'{}'} language="json" style={{
                            maxHeight: '500px',
                            fontFamily: 'monospace',
                            fontSize: '12px',
                            overflowY: 'auto',
                        }} />

                        {errors.metadata ? <div className="mt-2 text-danger">{errors.metadata}</div> : null}
                    </Card.Body>
                </Card>

            </Modal.Body>
            <Modal.Footer>
                {/* <Button variant="secondary" size="lg" onClick={() => {
                    return route(`/save-document`);
                }}>
                    <FontAwesomeIcon icon={faLink} className="me-2" />
                    Formulaire avancé
                </Button> */}

                {/* Close */}
                <Button variant="secondary" onClick={onHide}>
                    Fermer
                </Button>

                <Button variant="primary"  onClick={handleUpload} disabled={uploading}>
                    Uploader
                    <FontAwesomeIcon icon={faUpload} className="ms-2" />

                    {uploading ? <Spinner animation="border" size="sm" className="ms-2" /> : null}
                </Button>
            </Modal.Footer>
        </Modal>

    </>
}